import $ from 'jquery';
import { MQ } from '../tools/MQ.js';

export const init = () => {
	const snakeList = Array.from(document.querySelectorAll('.snake-alt__list'));
	if (snakeList.length === 0) {
		return;
	}
	const snakeNr = Array.from(document.querySelectorAll('.snake-alt'));
	snakeNr.forEach((item, index) => {
		const amount = snakeNr.length,
			order = ((index + 1) / amount) * 100,
			svgPath = item.querySelector('path');
		svgPath.setAttribute('stroke-dasharray', order + ',100');
		if (index + 1 === snakeNr.length) {
			item.classList.add('snake-alt--last');
		}
	});
	function sortItems() {
		snakeList.forEach((list, index) => {
			let row = 0;
			const lnum = 'list ' + index;
			const items = list.querySelectorAll('.snake-alt__item');
			items.forEach((item, index) => {
				const itemPrev = item.previousElementSibling;
				const itemNext = item.nextElementSibling;
				if (item.classList.contains('snake-alt__item--right')) {
					if (itemPrev) {
						if (!itemPrev.classList.contains('snake-alt__item--right')) {
							const title1 = itemPrev.querySelector('.snake-alt__item-title')
								? itemPrev.querySelector('.snake-alt__item-title').clientHeight
								: 0;
							//const title1 = itemPrev.querySelector('.snake-alt__item-title').clientHeight;
							//const title2 = item.querySelector('.snake-alt__item-title').clientHeight;
							const title2 = item.querySelector('.snake-alt__item-title')
								? item.querySelector('.snake-alt__item-title').clientHeight
								: 0;
							const msg1 = itemPrev.querySelector('.snake-alt__msg').clientHeight;
							const msg2 = item.querySelector('.snake-alt__msg').clientHeight;
							let h1 = msg1 + title1;
							let h2 = msg2 + title2;
							if (h1 >= h2) {
								let diff = h1 - h2 + 30;
								item.style.marginTop = diff + 'px';
							}
							const diff = itemPrev.clientHeight - item.clientHeight;
						} else {
							row = row + 1;
						}
					} else {
						row = row + 1;
					}
					if (itemNext) {
						if (!itemNext.classList.contains('snake-alt__item--right')) {
							const diff = item.clientHeight - itemNext.clientHeight;
							if (diff < 30 && diff >= 0) {
								//itemNext.style.marginTop = '30px';
							}
						}
					}
				} else {
					row = row + 1;
				}
				item.classList.add('snake-alt__row-' + row);
			});
		});
	}

	function checkItems() {
		if (MQ('mdUp')) {
			sortItems();
		} else {
			const items = document.querySelectorAll('.snake-alt__item');
			items.forEach((item) => {
				item.removeAttribute('style');
			});
		}
	}
	window.onresize = checkItems;
	checkItems();
};
